import { Box, Card, IconButton, Stack, Typography } from '@mui/material';

import { ReactComponent as DrawerClose } from 'common/assets/images/drawer-close.svg';
import { scrollProps } from 'common/utils/utilFunctions';

import { ISourcesDrawerProps } from '../api/type-def';

import styles from './SourcesDrawer.module.scss';

const SourcesDrawer = (props: ISourcesDrawerProps) => {
	const { sources, handleClickClose } = props;

	const { drawerCloseIconColor } = styles;

	return (
		<Box
			className={styles['detailed-container']}
			role="presentation"
			data-testid="groups-container"
		>
			<div className={styles['sources-top-div']}>
				<div
					className={styles['groups-text-background']}
					data-testid="sources-top-div"
				>
					<Stack
						direction="row"
						justifyContent="space-between"
						spacing={2}
						data-testid="close-button-stack"
					>
						<Typography className={styles['source-heading']}>
							Sources
						</Typography>
						<IconButton
							size="large"
							onClick={handleClickClose}
							data-testid="close-groups-btn"
							className={styles['close-icon']}
						>
							<DrawerClose fill={drawerCloseIconColor} />
						</IconButton>
					</Stack>
				</div>
			</div>
			<Card className={styles['sources-card']} sx={scrollProps('y-axis')}>
				{sources.map((source) => {
					const splitIndex = source.indexOf(']: ');
					const part1 = source.substring(1, splitIndex);
					const part2 = source.substring(splitIndex + 3);
					return (
						<Card key={part1} className={styles['sources-main']}>
							<Typography className={styles['sources-heading']}>
								{part1}
							</Typography>
							<Typography className={styles['sources-details']}>
								{part2}
							</Typography>
						</Card>
					);
				})}
			</Card>
		</Box>
	);
};

export default SourcesDrawer;
